import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "children"];
import React from "react";
import { Box, Flex, Span } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var formatPaymentMethodLabel = function formatPaymentMethodLabel(input) {
  var splitInput = input.split(" ");
  return ___EmotionJSX(Flex, {
    flexWrap: "wrap",
    color: "textTertiary"
  }, splitInput.map(function (word, index) {
    var isLastWord = index === splitInput.length - 1;

    if (/\$\d+/g.test(word)) {
      return ___EmotionJSX(Span, {
        key: index,
        fontWeight: "normal",
        fontSize: {
          xs: "sm",
          md: "base"
        }
      }, word, !isLastWord && ___EmotionJSX(React.Fragment, null, "\xA0"));
    }

    return ___EmotionJSX(Span, {
      key: index,
      fontSize: {
        xs: "sm",
        md: "base"
      }
    }, word, !isLastWord && ___EmotionJSX(React.Fragment, null, "\xA0"));
  }));
};
export var BNPLPaymentMethod = function BNPLPaymentMethod(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Flex, _extends({
    flexDirection: "column",
    justifyContent: "flex-start"
  }, props), ___EmotionJSX(Box, {
    mb: 1
  }, icon), children);
};
BNPLPaymentMethod.formatPaymentMethodLabel = formatPaymentMethodLabel;